export default __webpack_public_path__ + "static/countup-64900aa9ebae67980f4504d73cb74092.mp4";